import Logo from '@/assets/images/OMIKUJI Main Logo.png';

export default function BackgroundPanel() {
    return (
        <div className='min-h-screen bg-cover bg-center bg-login-bg'>
        </div>
    );
}
